module.exports = __webpack_public_path__ + "img/experience.efdc9163.png";